import qs from "qs";
import {apiVoissa} from "../../libs/api";
import moment from "moment";
import { getGenderLabel, trancheAge } from "../../libs/helper";
import posthog from "posthog-js";

const MONGO_OBJECT_ID_REGEXP = /^[0-9a-fA-F]{24}$/;

const normalizeObjectId = (value) => {
    if (typeof value !== "string") return null;
    const normalized = value.trim();
    return MONGO_OBJECT_ID_REGEXP.test(normalized) ? normalized : null;
};

export const signupUser = (data = {}, config = {}) => apiVoissa.post(`/users`, data, config);
export const loginUser = (data = {}, config = {}) => apiVoissa.post(`/users/login`, data, config);


export const fetchConfirmEmail = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/verify-email`, data, config);
export const fetchConfirmAccount = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/verify-account`, data, config);
export const verifyToken = ({ ephemeralToken = null, currentToken = null}, config = {}) => apiVoissa.post(`/users/accounts/verify-token`, {ephemeralToken, currentToken}, config)
export const forgotPasswordUser = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/forgot-password`, data, config);
export const resetPassword = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/reset-password`, data, config);
export const updateCurrentUserRightModerationTag = (config = {}) => apiVoissa.patch(`/users/me/update-right-moderation-tag`, '', config);

export const resetTokens = (data = {}, config = {}) => apiVoissa.post(`/users/me/tokens/reset`, data, config);

// MFA / TOTP
export const setupTotp = (config = {}) => apiVoissa.post(`/users/me/mfa/totp/setup`, '', config);
export const confirmTotp = (data = {}, config = {}) => apiVoissa.post(`/users/me/mfa/totp/confirm`, data, config);
export const disableTotp = (data = {}, config = {}) => apiVoissa.post(`/users/me/mfa/totp/disable`, data, config);
export const verifyTotpLogin = (data = {}, config = {}) => apiVoissa.post(`/users/accounts/totp/verify`, data, config);
export const sendMfaLoginEmailCode = (data = {}, config = {}) => apiVoissa.post(`/users/login/mfa/resend`, data, config);
export const verifyMfaLogin = (data = {}, config = {}) => apiVoissa.post(`/users/login/mfa/verify`, data, config);

//CURRENT USER

export const fetchUnreadRooms = (config = {}) => apiVoissa.get(`/users/me/rooms/unread`, config);
export const fetchUnreadNotifications = (config = {}) => apiVoissa.get(`/users/me/notifications/unread`, config);

export const requestSuppressionCurrentUser = (data = {}, config = {}) => apiVoissa.patch(`/users/me/request-suppression`, data, config);
export const cancelRequestSuppressionCurrentUser = (config = {}) => apiVoissa.get(`/users/me/cancel-request-suppression`, config);
export const deleteCurrentUser = (config = {}) => apiVoissa.delete(`/users/me/confirm-suppression`, config);

export const fetchUserIgnored = (query = {}, config = {}) => apiVoissa.get(`/users/me/users-ignored?${qs.stringify(query)}`, config);
export const createUserIgnored = (userId, config = {}) => apiVoissa.post(`/users/me/users-ignored/${userId}`, '', config);
export const deleteUserIgnored = (userId = {}, config = {}) => apiVoissa.delete(`users/me/users-ignored/${userId}`, config);

export const fetchMediaCommentsModeration = (kind = "medias", query = {}, config = {}) => apiVoissa.get(`/users/me/moderation-comments/${kind}?${qs.stringify(query)}`, config);

export const updateCurrentUserPassword = (config = {}) => apiVoissa.post(`/users/me/change-password`, '', config);
export const updateCurrentUserEmail = (data = {}, config = {}) => apiVoissa.patch(`/users/me/update-email`, data, config);
export const updateCurrentUserNotification = (data, config = {}) => apiVoissa.patch(`/users/me/update-notifications`, data, config);
export const updateCurrentUserLocation = (data, config = {}) => apiVoissa.patch(`/users/me/update-location`, data, config);
export const updateCurrentUserAppearInDating = (data, config = {}) => apiVoissa.patch(`/users/me/update-appear-in-dating`, data, config);
// Mode incognito (Voissa Max / Admin) : le réglage vit sur le compte, pas dans le navigateur —
// c'est l'API qui décide d'anonymiser une vue, elle doit donc en être la source de vérité.
export const updateCurrentUserIncognito = (incognitoEnabled, config = {}) =>
    apiVoissa.patch(`/users/me/set-toggle-incognito`, { incognitoEnabled }, config);

export const updateCurrentUser = (data, config = {}) => {
    if(data?.usersIgnored){
        delete data.usersIgnored;
    }
    if(data?.friends){
        delete data.friends;
    }
    if(data?.location){
        delete data.location;
    }
    return apiVoissa.patch(`/users/me`, data, config);
};

export const updateEmailCurrentUser = (data = {}, config = {}) => apiVoissa.patch(`/users/me/update-emailunconfirmed`, data, config);
export const sendEnrollmentEmailCurrentUser = (data = {}, config = {}) => apiVoissa.patch(`/users/me/send-emailunconfirmed`, data, config);

export const fetchCommentsToModerate = (type, parentId, query, config = {}) => apiVoissa.get(`/users/me/moderation-comments/${type}/${parentId}?${qs.stringify(query)}`, config);

export const fetchCurrentUserAbo = (query = {}, config = {}) => apiVoissa.get(`/users/me/abo`, config);
export const fetchCurrentUserSubscription = (query = {}, config = {}) => apiVoissa.get(`/users/me/subscription`, config);

export const fetchCertificationStatus = (config = {}) => apiVoissa.get(`/users/me/certification-status`, config);

// --- CERTIFICATION BLUE (capture live via caméra) --- //

// Chemins d'upload par type de certification (le backend attend le champ fichier `file`)
const CERTIFICATION_UPLOAD_PATHS = {
    'certification-video': `/users/me/upload-certification-video`,
    'certification-photo': `/users/me/upload-certification-photo`,
};

/**
 * Ouvre une demande de certification et récupère le code à recopier sur un papier.
 * Un seul code par utilisateur (indépendant du mode photo/vidéo).
 * @param {{regenerate?: boolean}} [options] - regenerate: invalide l'ancien code et en génère un nouveau.
 * @returns {Promise<{code:string, expiresAt:string, ttlMinutes:number}>}
 */
export const requestCertificationCode = ({ regenerate = false } = {}) =>
    apiVoissa.post(`/users/me/certification/code`, { regenerate });

/**
 * Soumet la capture (blob vidéo ou photo) en multipart/form-data.
 * On ne fixe pas manuellement le Content-Type : axios ajoute automatiquement
 * la bonne frontière (boundary) quand le corps est un FormData (cf. UploaderLib).
 * @param {object} params
 * @param {string} params.kind - 'certification-video' | 'certification-photo'
 * @param {Blob}   params.blob - la capture caméra
 * @param {string} params.consentVersion - version du consentement RGPD accepté
 * @param {string} [params.filename] - nom de fichier optionnel
 */
export const submitCertificationCapture = ({ kind, blob, consentVersion, filename } = {}, config = {}) => {
    const path = CERTIFICATION_UPLOAD_PATHS[kind];
    if (!path) {
        return Promise.reject(new Error(`Type de certification inconnu : ${kind}`));
    }
    const defaultName = kind === 'certification-photo' ? 'certification.jpg' : 'certification.webm';
    const formData = new FormData();
    formData.append('file', blob, filename || defaultName);
    formData.append('consentVersion', consentVersion);
    return apiVoissa.post(path, formData, {
        timeout: 120000, // l'upload d'une vidéo peut dépasser le timeout par défaut (10s)
        ...config,
    });
};

/**
 * Conteste un refus de certification.
 * @param {string} certificationId - ID de la certification refusée
 * @param {string} message - message de contestation
 * @returns {Promise<{data:object}>}
 */
export const contestCertification = (certificationId, message, config = {}) =>
    apiVoissa.post(`/users/me/certifications/${certificationId}/contest`, { message }, config);

// --- END CERTIFICATION BLUE --- //

export const fetchCurrentUserHasActiveSubscription = (query = {}, config = {}) => apiVoissa.get(`/users/me/subscriptions/is-active`, config);

export const fetchCountMessenger = (config = {}) => {
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
    const normalizedToken = String(token || '').trim();
    const hasValidToken = !!normalizedToken && !["undefined", "null"].includes(normalizedToken.toLowerCase());
    if (!hasValidToken) {
        return Promise.resolve({ total: 0 });
    }
    return apiVoissa.get(`/users/me/count-messenger`, config);
};

//export const updateConfirmedAge = (data = {},config = {}) => apiVoissa.post(`/users/me/confirmed-age`, data, config);
export const updateConfirmedAge = (url = "", data = {},config = {}) => apiVoissa.post(url, data, config);
export const clickConfirmedAge = (data = {},config = {}) => apiVoissa.post(`/users/me/click-confirmed-age`, data, config);
export const openConfirmedAge = (data = {},config = {}) => apiVoissa.post(`/users/me/open-confirmed-age`, data, config);
export const generateUrlAgeConfirmation = (query = {},config = {}) => apiVoissa.get(`/users/me/generate-url-age-verification?${qs.stringify(query)}`, config);

export const confirmedAgeVerif = (data = {},config = {}) => apiVoissa.post(`users/me/ageverif`, data, config);

function calculateAge(birthdate) {
    try{
        const birthDate = moment(birthdate);
    const today = moment();
    return today.diff(birthDate, 'years');
    }
    catch(e){
        return 0;
    }
}

function trackCurrentUser(currentUser){
    try {
        const age1 = calculateAge(currentUser?.profile?.informations[0]?.birthday);
        const age2 = calculateAge(currentUser?.profile?.informations[1]?.birthday);
        const age_average = age2 > 0 ? Math.round((age1 + age2) / 2) : age1;
        const trackingProps = {
            user_id: currentUser?._id, 
            logged_in: true, 
            avatar : currentUser?.profile?.avatar,
            subscribed: currentUser?.subscription?.hasAccess,
            isPremium: currentUser?.subscription?.isPremium,
            isPrivileged: currentUser?.subscription?.isPrivileged,
            plan: currentUser?.subscription?.plan || null,
            isTrial: currentUser?.subscription?.isTrial || false,
            canStartTrial: currentUser?.subscription?.canStartTrial || false,
            username: currentUser?.username,
            certified: currentUser?.isCertified,
            age_avg_range: trancheAge(age_average, false),
            age1_range : trancheAge(age1, false),
            age2_range : trancheAge(age2, false),
            birthday : currentUser?.profile?.informations[0]?.birthday,
            birthday2 : currentUser?.profile?.informations[1]?.birthday,
            memberSince : currentUser.createdAt,
            gender : currentUser?.profile?.gender || 0,
            gender_str: getGenderLabel(currentUser?.profile?.gender),
            ageVerificated: currentUser?.ageVerificated || false,
            role : currentUser?.role,
        };
        posthog.identify(currentUser?._id, trackingProps);
        const scriptTag = document.querySelector('script[data-domain="voissa.com"]');
        if(!scriptTag.getAttribute('event-logged_in')) window.plausible('pageview', {props: trackingProps});
        Object.keys(trackingProps).map(key=>scriptTag.setAttribute(`event-${key}`, trackingProps[key]));
    }
    catch(e) {return false};
}

export const fetchUserCurrent = async (config) => {
    const currentUser = await apiVoissa.get(`/users/me`, config);
    if(currentUser?._id) trackCurrentUser(currentUser);
    return currentUser;
};

// USER

export const fetchUsersStaff = (query = {}, config = {}) =>apiVoissa.get(`/users?staff=true`, config);
export const fetchUsersMeet = (query = {}, config = {}) =>apiVoissa.get(`/meets/users?${qs.stringify(query)}`, config);

export const fetchUsers = (query = {}, config = {}) =>apiVoissa.get(`/users?${qs.stringify(query)}`, config);

export const searchUsers = (data = {}, config = {}) =>apiVoissa.post(`/users/search`, data, config);
export const fetchUser = (userId, config = {}) => apiVoissa.get(`/users/${userId}`, config);
export const setCountViewUser = (userId, config = {}) => apiVoissa.patch(`/users/${userId}/view`, '', config);

export const fetchUserTimelines = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/feed?${qs.stringify(query)}`, config);

export const fetchUserSanctions = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/sanctions?${qs.stringify(query)}`, config);


/**
 * Conteste une sanction utilisateur
 * @param {string} userId - ID de l'utilisateur
 * @param {string} sanctionId - ID de la sanction à contester
 * @param {object} data - Données envoyées ({ message })
 * @param {object} config - Axios config optionnel
 */
export const contestUserSanction = (userId, sanctionId, data = {}, config = {}) =>
  apiVoissa.post(`/users/${userId}/sanctions/${sanctionId}/contest`, data, config);


export const fetchUserWarnings = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/warnings?${qs.stringify(query)}`, config);

export const createUserWarning = (userId, data = {}, config = {}) => apiVoissa.post(`/users/${userId}/warnings`, data, config);
export const updateUserWarningAccepted = (userId, warningId = null, config = {}) => apiVoissa.patch(`/users/${userId}/warnings/${warningId}/accepted`, {}, config);
export const deleteUserWarningAccepted = (userId, warningId = null, config  ={}) => apiVoissa.delete(`/users/${userId}/warnings/${warningId}`, config);

export const fetchUserRelationCounts = (userId, query = {}, config) => apiVoissa.get(`/users/${userId}/relations/count`, config);
export const fetchUserStats = (userId, query = {}, config) => apiVoissa.get(`/users/${userId}/stats`, config);
// Statistiques membres (premium) — dashboard perso + liste des membres
export const fetchStatsDashboard = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/stats/dashboard?${qs.stringify(query)}`, config);
export const fetchStatsMembers = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/stats/members?${qs.stringify(query)}`, config);
export const STATS_DASHBOARD_KEY = `stats-dashboard`;
export const STATS_MEMBERS_KEY = `stats-members`;
// Nouveaux fans (tendance + liste) et reach (chiffres de visibilité)
export const fetchStatsNewFans = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/stats/new-fans?${qs.stringify(query)}`, config);
export const fetchStatsReach = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/stats/reach?${qs.stringify(query)}`, config);
// Top contenus (podium médias/articles par vues/likes/commentaires, fenêtre ≤ 30 j)
export const fetchStatsTopContents = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/stats/top-contents?${qs.stringify(query)}`, config);
export const STATS_NEW_FANS_KEY = `stats-new-fans`;
export const STATS_REACH_KEY = `stats-reach`;
export const STATS_TOP_CONTENTS_KEY = `stats-top-contents`;
export const fetchUserFriends = (userId, query = {}, config) => apiVoissa.get(`/users/${userId}/relations/friends?${qs.stringify(query)}`, config);

export const fetchUserMemberCircle = (userId, query = {}, config) => apiVoissa.get(`/users/${userId}/relations/member-circle?${qs.stringify(query)}`, config);
export const fetchUserStateCircle = (userId, config) => apiVoissa.get(`/users/${userId}/relations/state-circle`, config);

//export const fetchUserFriendsRequest = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/relations/friend-requests?${qs.stringify(query)}`, config);
//export const createUserFriendsRequest = (userId, data = {}, config = {}) => apiVoissa.post(`/users/${userId}/relations/friend-requests`, data, config);
export const fetchUserRandomQuestions = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/random-questions?${qs.stringify(query)}`, config);

const withTrackerDeleteConfig = (config = {}, tracker = null) => {
    if (!tracker) {
        return config;
    }

    return {
        ...config,
        data: {
            ...(config?.data || {}),
            tracker,
        }
    };
};

//export const acceptedUserFriendRequest = (userId, answerId, config = {}) => apiVoissa.patch(`/users/${userId}/relations/friend-requests/${answerId}/accepted`, {}, config);
//export const refusedUserFriendRequest = (userId, answerId, config = {}) => apiVoissa.patch(`/users/${userId}/relations/friend-requests/${answerId}/refused`, {}, config);

//export const updateUserFriendFavorite = (userId, friendId = null, config = {}) => apiVoissa.patch(`/users/${userId}/relations/friends/${friendId}/update-favorite`, {}, config);
export const deleteUserFriend = (friendId = null, tracker = null, config = {}) => apiVoissa.delete(`/users/me/relations/friends/${friendId}`, withTrackerDeleteConfig(config, tracker));
export const createUserFriend = (data = {}, config = {}) => apiVoissa.post(`/users/me/relations/friends/`, data, config);

export const fetchUserStatus = (userId, statusId, query = {}, config = {}) => apiVoissa.get(userId ? `/users/${userId}/status/${statusId}?${qs.stringify(query)}` : `/status/${statusId}?${qs.stringify(query)}`, config);
export const createUserStatus = (userId, data, config = {}) => apiVoissa.post(`/users/${userId}/status/`, data, config);
export const updateUserStatus = (userId, statusId, data = {}, config = {}) => apiVoissa.patch(`/users/${userId}/status/${statusId}`, data, config);
export const deleteUserStatus = (userId, statusId = {}, config = {}) => apiVoissa.delete(`/users/${userId}/status/${statusId}`, config);

export const fetchUserNotificationStatus = (userId, notificationId, config = {}) => apiVoissa.get(`users/${userId}/notifications/${notificationId}/status`,config);

export const fetchUserNotifications = (query = {}, config = {}) => apiVoissa.get(`/users/me/notifications?${qs.stringify(query)}`, config);
export const markUserNotificationOpen = (notificationId = null, config ={}) => apiVoissa.patch(`/users/me/notifications/open/${notificationId}`, {}, config);
export const markUserAllNotificationOpen = (config ={}) => apiVoissa.patch(`/users/me/notifications/open`, {}, config);

export const fetchUserArticles = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/articles?${qs.stringify(query)}`, config);

export const fetchUserAlbums = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/albums?${qs.stringify(query)}`, config);

export const fetchUserAlbum = (userId, albumId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/albums/${albumId}?${qs.stringify(query)}`, config);
export const createUserAlbum = (userId, data, config = {}) => apiVoissa.post(`/users/${userId}/albums`, data, config);
export const updateUserAlbum = (userId, albumId, data, config = {}) => apiVoissa.patch(`/users/${userId}/albums/${albumId}`, data, config);
export const deleteUserAlbum = (userId, albumId = {}, config = {}) => apiVoissa.delete(`/users/${userId}/albums/${albumId}`, config);

export const fetchUserProfileMedias = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/profile-medias?${qs.stringify(query)}`);

export const followingUser = (userId, profilId, config = {}) => {
    const normalizedUserId = normalizeObjectId(userId);
    const normalizedProfileId = normalizeObjectId(profilId);

    if (!normalizedUserId || !normalizedProfileId || normalizedUserId === normalizedProfileId) {
        return Promise.resolve({ isFollow: false, followId: null, isFollowBack: false, isFriend: false });
    }

    return apiVoissa.get(`/users/${normalizedUserId}/relations/followers/${normalizedProfileId}`, config);
};
export const createFollowingUser = (userId, data = {}, config = {}) => apiVoissa.post(`/users/${userId}/relations/following-profile`, data, config);
export const deleteFollowingUser = (userId, profileId, tracker = null, config = {}) => apiVoissa.delete(`/users/${userId}/relations/following-profile/${profileId}`, withTrackerDeleteConfig(config, tracker));

export const fetchUserFollowings = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/relations/followings?${qs.stringify(query)}`, config);
export const fetchUserFollowers = (userId, query = {}, config = {}) => apiVoissa.get(`/users/${userId}/relations/followers?${qs.stringify(query)}`, config);


export const fetchUserByIp = (data = {}, config = {}) => apiVoissa.post(`/users/find-ip`, data, config);


export const fetchUserSessions = (userId = null, config = {}) => apiVoissa.get(`/users/${userId}/sessions-group`, config);

export const fetchUserBookmarksMedias = (query = {}, config = {}) => apiVoissa.get(`/users/me/bookmarks/medias?${qs.stringify(query)}`, config);

export const fetchUserTokenVMessenger = (data = {}, config = {}) => apiVoissa.post(`/users/me/login-vmessenger`, data, config);

export const fetchUserPostsThreads = (userId = null,query = {}, config = {}) => apiVoissa.get(`/users/${userId}/threads?${qs.stringify(query)}`, config);
export const fetchUserPostsThreadsResponses = (userId = null,query = {}, config = {}) => apiVoissa.get(`/users/${userId}/responses-threads?${qs.stringify(query)}`, config);


// --- CERTIFICATION VIDÉO REMINDER --- //

/**
 * Récupère les infos de rappel de certification vidéo
 * (doit-on afficher la modale, jours restants, date d’expiration, etc.)
 */
export const fetchVideoCertificationReminder = (config = {}) =>
  apiVoissa.get(`/users/me/certifications/video/reminder`, config);

/**
 * Met à jour l’état du rappel de certification vidéo
 * (prise de connaissance ou "me le rappeler dans 7 jours")
 * @param {string} action - 'ack' | 'snooze7'
 */
export const updateVideoCertificationReminder = (action = 'ack', config = {}) =>
  apiVoissa.post(`/users/me/certifications/video/reminder`, { action }, config);

// --- END CERTIFICATION VIDÉO REMINDER --- //

export const USER_TOKEN_KEY = `user-token`;
export const USER_SET_COUNT_VIEW = `user-set-count-view`;
export const USER_CURRENT_KEY = `user-current`;
export const USER_KEY = `user`;
export const USER_UNREAD_ROOMS_KEY = `user-unread-rooms`;
export const USER_UNREAD_NOTIFICATIONS_KEY = `user-unread-notifications`;
export const USER_CURRENT_AGE_VERIFICATION_KEY = `user-current-age-verification`;

export const USER_CURRENT_IGNORE_KEY = `user-current-users-ignore`;
export const USER_CURRENT_COMMENTS_MODERATION_KEY = `user-current-comments-moderation`;
export const USER_CURRENT_CERTIFICATION_STATUS_KEY = `user-current-certification-status`

export const USER_CURRENT_MODERATION_COMMENTS_MEDIAS_KEY = `user-current-moderation-comments-medias`;
export const USER_CURRENT_MODERATION_COMMENTS_ARTICLES_KEY = `user-current-moderation-comments-articles`;

export const USER_CURRENT_OPEN_AGE_CONFIRMATION_KEY = `user-current-open-age-confirmation`;

export const USER_CURRENT_SANCTIONS_KEY = `user-current-sanctions`;
export const USER_CURRENT_REPORT_RESOLUTIONS_KEY = `user-current-report-resolutions`;

export const USER_WARNINGS_KEY = `user-warnings`;
export const USER_RELATION_COUNT_KEY = `user-relations-count`;
export const USER_STATS_KEY = `user-stats`;
export const USER_RELATION_STATE_CIRCLE_KEY = `user-relations-state-circle`;
export const USER_MEMBER_CIRCLE_KEY = `user-member-circle`;
export const USER_FRIENDS_KEY = `user-friends`;
export const USER_FRIENDS_SEARCH_KEY = `user-friends-search`;

export const USER_CIRCLE_SEARCH_KEY = `user-circle-search`;

export const USER_STATUS_KEY = `user-status`;
export const USER_NOTIFICATION_STATUS_KEY = `user-notification-status`;
export const USER_NOTIFICATIONS_KEY = `user-notifications`;
export const USER_ARTICLES_KEY = `user-articles`;
export const USER_THREADS_KEY = `user-threads`;
export const USER_THREADS_RESPONSES_KEY = `user-threads-responses`;
export const USER_ALBUMS_KEY = `user-albums`;
export const USER_ALBUM_KEY = `user-album`;

export const USER_PROFILE_MEDIAS_KEY = `user-profile-medias`;
export const USER_BEST_VIDEOS_KEY = `user-best-videos`;
export const USER_BEST_PHOTOS_KEY = `user-best-photos`;

export const USER_FIL_ACTUALITY_KEY = `user-fil-actuality`;

export const USER_FOLLOWER_KEY = `user-follower`;

export const USER_FOLLOWERS_KEY = `user-followers`;
export const USER_FOLLOWINGS_KEY = `user-followings`;

export const USER_LIST_USERS_BY_IP_KEY = `user-list-users-by-ip`;

export const USER_LIST_SESSION_KEY = `user-list-session`;
export const USER_BOOKMARKS_MEDIAS_KEY = `user-bookmarks-medias`;

export const USERS_KEY = `users`;
export const USERS_STAFF_KEY = `users-staff`;
export const USERS_MEET_KEY = `users-meet`;

export const USER_CURRENT_COUNT_MESSENGER_KEY = `user-current-count-messenger`;

export const USER_CURRENT_VIDEO_CERT_REMINDER_KEY = `user-current-video-certification-reminder`;